export const cilSync = ["24 24","<path d='M19.227 6.237l-1.357-1.357 3.882-0.004-0.002-1.5-6.374 0.007v6.368h1.5v-3.744l1.291 1.291c1.294 1.294 2.094 3.081 2.094 5.055 0 3.944-3.193 7.141-7.135 7.148h-0.001l0.003 1.5c4.77-0.009 8.633-3.877 8.633-8.648 0-2.388-0.968-4.55-2.533-6.115v0z'></path><path d='M10.876 4.875l-0.003-1.5c-4.77 0.009-8.633 3.877-8.633 8.648 0 2.388 0.968 4.55 2.533 6.115l1.362 1.362h-3.885v1.5h6.375v-6.375h-1.5v3.744l-1.291-1.291c-1.294-1.294-2.094-3.081-2.094-5.055 0-3.944 3.193-7.141 7.135-7.148h0.001z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-sync.js
// module id = null
// module chunks = 